import React, {useEffect, useRef, useState} from "react";
import Spinner from "reactjs-simple-spinner";
import Form from "react-validation/build/form";
import logo from "../../assets/images/logo.jpg";
import Input from "react-validation/build/input";
import {Link} from "react-router-dom";
import CheckButton from "react-validation/build/button";
import {makeStyles} from "@material-ui/core/styles";
import UserService from "../../services/UserService";
import {toast, ToastContainer} from "react-toastify";


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > * + *': {
            marginLeft: theme.spacing(2),
        },
    },
}));

const ResetPassword = (props) => {
    const form = useRef();
    const checkBtn = useRef();
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => {
        setLoading(false);
        setMessage('');
    }, []);

    const classes = useStyles();

    const handleChangeEmail = (e) => {
        setEmail(e.target.value)
    }

    const handleReset = (e) => {
        setLoading(true);
        e.preventDefault();

        UserService.resetPassword(email)
            .then(res => {
                if (res.status === 200) {
                    console.log(res);
                    setLoading(false);
                    toast('Email Sent Successfully', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else {
                     toast.warning('Operation Failed: ' + res, {
                         position: "top-center",
                         autoClose: 3000,
                         hideProgressBar: false,
                         closeOnClick: true,
                         pauseOnHover: true,
                         draggable: true,
                         progress: undefined,
                     });
                    setLoading(false);
                }
            }).catch(err => {
            console.log(err);
            toast.warning('Operation Failed: ' + err, {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setLoading(false);
        })
    }

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            {loading && (
                <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                    <Spinner
                        size="large"
                        message="Please wait....."
                        line-fg-color="#64c3c2"
                    />
                </div>
            )}
            {!loading && (
                <div>
                    <div className="container" style={{marginTop: 100}}>
                        <div className="row">
                            <div className="col-lg-4 col-md-6 ml-auto mr-auto">
                                <div className="card card-login"
                                >
                                    <Form onSubmit={handleReset} ref={form}
                                          className="form container" id="login-form"

                                    >
                                        <center>
                                            <p className="mt-5"><a href="#" className="logo2"/></p>
                                            <img src={logo} width={150} alt="logo"/>
                                        </center>

                                        <div className="card-body">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                 <span className="input-group-text">
                                                  <i className="fa fa-user"/>
                                                </span>
                                                </div>
                                                <Input
                                                    type="email"
                                                    required={true}
                                                    className="form-control"
                                                    placeholder="Email"
                                                    onChange={handleChangeEmail}
                                                />
                                                <br/>
                                            </div>

                                        </div>


                                        <center>
                                            <button
                                                className="btn btn-round btn-primary btn-sm "
                                                onClick={handleReset}
                                                type="submit"
                                            >
                   <span style={{fontSize: 16}}>
                  Submit&nbsp;<i className="fa fa-external-link"/>
                  </span>

                                            </button>
                                        </center>
                                        <hr/>
                                        <div
                                            className="footer text-center font-weight-bold"
                                            style={{paddingLeft: 35}}
                                        >
                                            <span className="font-weight-light">Remember password?</span>
                                            <br/>
                                            <Link to="/login">
                                                &nbsp;<span className="text-center"><a>Proceed To Sign In</a></span>
                                            </Link>
                                        </div>
                                        <CheckButton style={{display: "none"}} ref={checkBtn}/>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default ResetPassword;
